export default{
	drawPreview: 4,
	rows:8,
	columns: 10,
	countdownDuration: 12,
	flowSpeed: 4,
	numDrawTiles:100
}